import { Row } from "read-excel-file";
import { FuelSlipImport, FuelSlipUploadPreference } from "../models/fuel-recon.model";
import { dateTimeCultures } from "../../../_shared/constants/date-time-culture.constant";
import { parse as parseWithFormat } from "date-fns";

export function convertRowToFuelSlipImport(rows: Row[], userName: string, createdAt: Date, fuelSlipUploadPreference: FuelSlipUploadPreference): FuelSlipImport[] {
  const fuelSlips = rows.map((r: any) => {
    const result: FuelSlipImport = {
      amount: r[fuelSlipUploadPreference.volumeColumn - 1] as number,
      currencyId: fuelSlipUploadPreference.currencyId,
      isTotalCost: r[fuelSlipUploadPreference.amountTypeColumn - 1],
      assetName: `${r[fuelSlipUploadPreference.assetColumn - 1]}`,
      cost: r[fuelSlipUploadPreference.amountColumn - 1] as number,
      fuelSlipDate: parseDateStringToDate(r[fuelSlipUploadPreference.dateColumn - 1], fuelSlipUploadPreference.dateTimeCulture) as Date,
      createdBy: userName,
      createdAt
    };
    return result;
  });

  return fuelSlips;
}

export function parseDateStringToDate(dateString: string, dateTimeCulture: string): Date {
  const format = Object.keys(dateTimeCultures).find(
    key => dateTimeCultures[key] === dateTimeCulture
  );
  let result: Date = new Date(NaN);
  const value = (dateString ?? '').toString().trim();

  if (value.length > 0) {
    if (format) {
      const parsed = parseWithFormat(value, format, new Date());
      if (!Number.isNaN(parsed.getTime())) {
        result = parsed;
      }
    }

    // fallback to native Date parsing if custom format parsing failed
    if (Number.isNaN(result.getTime())) {
      const native = new Date(value);
      if (!Number.isNaN(native.getTime())) {
        result = native;
      }
    }
  }

  return result;
}
